import { defineComponent as _defineComponent } from 'vue'
import { useVuetify } from '@/composables/useVuetify'
import LefebvreLogoComponent from '@/components/Logo/LefebvreLogoComponent.vue'

// COMPOSABLES

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const { isMobileBreakpoint } = useVuetify()

return { __sfc: true,isMobileBreakpoint, LefebvreLogoComponent }
}

})